export const homePageName = 'home';

export const administrationPageName = 'administration';
export const userAdministrationPageName = 'user-administration';
export const clientAdministrationPageName = 'client-administration';

export const exportConfigurationPageName = 'export-configuration';
export const configurationsPageName = 'configurations';
export const configurationTemplatesPageName = 'configuration-templates';
export const fieldValueReplacementsPageName = 'field-value-replacements';
export const fieldAssignmentTemplatesPageName = 'field-assignment-templates';
export const emailTemplatesPageName = 'email-templates';
export const activationEmailTemplatesPageName = 'activation-email-templates';
export const historyPageName = 'history';

export const assetsPageName = 'assets';
export const productAssetsPageName = 'product-assets';
export const brandLogosPageName = 'brand-logos';
export const assetsStoragePageName = 'assets-storage';
export const assetCollectionsPageName = 'asset-collections';
export const assetsStorageSettingsPageName = 'storage-settings';

export const manualImportPageName = 'manual-import';
export const manualImportSalesOrdersPageName = 'sales-orders';
export const manualImportVendorDeliveryDatePageName = 'vendor-delivery-date';
export const manualImportSerialNumbersPageName = 'serial-numbers';

export const importConfigurationsPageName = 'import-configurations';
export const importConfigurationsConfigurationPageName = 'configurations';
export const importConfigurationsGlobalPageName = 'global-configurations';
export const importConfigurationCreatePageName = 'create';
export const importConfigurationsProtocolPageName = 'import-configurations-protocol';
export const importConfigurationsResponsePageName = 'response';

export const acodisWorkflowsPageName = 'acodis-workflows';
export const acodisWorkflowCreatePageName = 'create';

export const configurationGeneralPageName = 'general';
export const configurationBacklogPageName = 'backlog';
export const configurationFinancePageName = 'finance';
export const configurationTimeSchedulePageName = 'time-schedule';
export const configurationEmailPageName = 'email';
export const configurationSftpPageName = 'sftp';
export const configurationFtpPageName = 'ftp';
export const configurationRestPageName = 'rest';
export const configurationAs2PageName = 'as2';
export const configurationFilePageName = 'file';
export const configurationResponsePageName = 'response';
export const configurationManualImportPageName = 'manual-import';
export const configurationFileGeneralPageName = 'file-general';
export const configurationFileColumnBasedPageName = 'column-based';
export const configurationFileEdifactPageName = 'edifact';
export const configurationFileAcodisPageName = 'file-acodis';
export const configurationFileFilterPageName = 'filter';
export const configurationFileLineBasedPageName = 'fields';
export const exportConfigurationCreatePageName = 'create';
export const configurationAcodisPageName = 'acodis';

export const settingsPageName = 'settings';
export const emailSettingsPageName = 'email-settings';

export const setPasswordPageName = 'set-password';
export const forgotPasswordPageName = 'forgot-password';
export const changePasswordPageName = 'change-password';
export const editProfilePageName = 'edit-profile';
export const loginPageName = 'login';
export const localLoginPageName = 'local';
export const userEditPageName = 'user-edit';
export const twoFactorAuthenticationPageName = 'two-factor-authentication';
export const registrationPageName = 'registration';
export const recoveryPageName = 'recovery';
export const onboardingPageName = 'onboarding';

export const vendorScoreCardPageName = 'vendor-score-card';
export const vendorScoreCardSurveyPageName = 'vendor-survey';
export const vendorScoreCardAdministrationPageName = 'administration';
export const vendorScoreCardVendorsPageName = 'vendors';

export const assetCollectionPublicViewPageName = 'asset-collection-view';